import React from 'react';
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { makeStyles } from '@mui/styles';

const stages = ["New", "CXD Privacy", "P&G Privacy", "Legal", "Completed"];
const arrowClipPath = "polygon(0 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 0 100%, 20px 50%)";

const useStyles = makeStyles(() => ({
  arrowWrapper: {
    display: 'flex',
    justifyContent: 'space-evenly',
    gap: '10px',
    marginRight: '100px'
  },
  arrowItem: {
    position: 'relative',
    width: '170px',
    minWidth: '170px',
    height: '45px',
    boxSizing: 'border-box',
    color: '#333',
    padding: '0 32px',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //backgroundColor: '#6d717b',
    clipPath: arrowClipPath,
    WebkitClipPath: arrowClipPath,
    userSelect: 'none',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: '1px',
      backgroundColor: '#EEF4FF',
      clipPath: arrowClipPath,
      WebkitClipPath: arrowClipPath,
      zIndex: 0
    }
  },
  arrowItemActive: {
    color: '#000',
    '&::before': {
      backgroundColor: '#EEB500'
    }
  },
  arrowText: {
    fontSize: '14px',
    whiteSpace: 'nowrap',
    position: 'relative',
    zIndex: 1
  }
}));

const getActiveStageIndex = (activeStage) => {
  if (typeof activeStage === 'number') return activeStage;

  const stageIndex = stages.findIndex((stage) => stage.toLowerCase() === String(activeStage || '').toLowerCase());
  return stageIndex === -1 ? 0 : stageIndex;
};

const Arrow = ({ activeStage = 1}) => {
  const classes = useStyles();
  const activeStageIndex = getActiveStageIndex(activeStage);

  return (
    <Box className={classes.arrowWrapper}>
      {stages.map((stage, index) => {
        const isActive = index === activeStageIndex;
        return (
          <Box 
            key={index}
            className={`${classes.arrowItem} ${isActive ? classes.arrowItemActive : ''}`}>
            <Typography className={classes.arrowText}>{stage}</Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default Arrow;